import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import App from './App.vue'
import router from './router'
import { setupStore } from './store'
import { setupRouterGuard } from './router/guard'
import { APP_TITLE } from './settings'
import '@/assets/styles/index.scss'

NProgress.configure({ showSpinner: false })

document.title = APP_TITLE

async function bootstrap() {
  const app = createApp(App)

  // 图标全量注册：旧工程用 iconfont 类名，迁移期可先换成 Element 图标
  for (const [key, comp] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, comp)
  }

  app.use(ElementPlus, { locale: zhCn, size: 'default' })

  setupStore(app)
  setupRouterGuard(router)

  app.use(router)

  await router.isReady()
  app.mount('#app')
}

bootstrap()
